import * as React from 'react';

interface Props {
    className?: string;
    onClick?: (e?: any) => void;
}

export const CrossIcon: React.FC<Props> = (props: Props) => (
    <svg
        className={props.className}
        onClick={props.onClick}
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fillRule="evenodd" clipRule="evenodd" d="M3.33033 4.91061L0.367188 1.69265L1.83845 0.337891L4.68971 3.43434L7.54097 0.337891L9.01223 1.69265L6.04909 4.91061L9.0101 8.12624L7.53883 9.48101L4.68971 6.38688L1.84059 9.48101L0.369322 8.12624L3.33033 4.91061Z" fill="var(--system-red)"/>
    </svg>
);
